import locale from 'antd/es/date-picker/locale/pt_BR';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';

import { DateRangePickerProps } from './DateRangePicker.interface';
import * as S from './DateRangePicker.style';

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startValue,
  endValue,
  onChange,
  picker,
  placeholder = ['Selecione', 'Selecione'],
  ...props
}) => {
  const handleChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    onChange(
      dates?.map(date => (date ? date.format('YYYY-MM-DD') : '')) as [
        string,
        string,
      ]
    );
  };

  return (
    <S.DateRangePickerContainer
      locale={locale}
      value={
        startValue && endValue
          ? [dayjs(startValue), dayjs(endValue)]
          : undefined
      }
      placeholder={placeholder as [string, string]}
      onChange={handleChange}
      picker={picker}
      format={'DD/MM/YYYY'}
      {...props}
    />
  );
};
